<template>
  <div class="verify_mfa_area container-fluid">
    <div class="row">
      <div class="col">
        <h2 class="mb-5">Enter the code you received.</h2>
        <input
          type="text"
          class="form-control"
          id="inputCode"
          name="code"
          placeholder="Enter code"
          v-model="code"
          v-on:click="clearErrors()"
          @keypress="checkEnter"
        />
        <p class="mt-3">
          Didn't receive a code?
          <a
            class="forgot-password-link-mfa"
            href="javascript:void(0);"
            v-on:click="resendCode()"
          >
            Send another one.
          </a>
        </p>
      </div>
      <div class="col text-center">
        <img
          style="max-width: none"
          class="img-responsive"
          src="\images\mfa-security-icon.png"
          title="MFA Security Image"
        />
      </div>
    </div>

    <div class="py-5">
      <div class="row">
        <div class="col pb-3 text-center">
          <p
            class="my-1"
            :class="has_error ? 'error-message' : 'success-message'"
          >
            {{ this.message }}
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col text-center">
          <button
            type="button"
            :disabled="is_loading ? true : false"
            :class="is_loading ? 'button-grey' : 'button-green'"
            class="btn px-5"
            v-on:click="verifyCode()"
          >
            <template v-if="is_loading">Verifying code...</template>
            <template v-else>Submit</template>
          </button>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal_mfa_save" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content" style="background-color: #dbdcde !important">
          <div class="modal-body" style="min-height: auto !important">
            <div class="save_mfa_area container-fluid">
              <div class="row">
                <div class="col text-center">
                  <h2 class="my-3">Do you want to remember this device?</h2>
                  <p
                    :class="
                      saving_has_error ? 'error-message' : 'success-message'
                    "
                  >
                    {{ this.saving_message }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer p-3">
            <button
              type="button"
              class="btn px-5"
              :disabled="saving_mfa_info ? true : false"
              :class="saving_mfa_info ? 'button-grey' : 'button-green'"
              v-on:click="saveMFAInfo()"
            >
              Yes
            </button>

            <button
              type="button"
              class="btn px-5 button-grey"
              v-on:click="redirectUser()"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VerifyMFAComponent',
    props: {
      user_id: Number,
      redirect: String,
      email: String,
      password: String,
      mfa_type: String,
    },

    data: function () {
      return {
        is_loading: false,
        message: '',
        has_error: false,
        code: '',
        resend_code_is_loading: false,
        saving_mfa_info: false,
        saving_has_error: false,
        saving_message: '',
      };
    },

    mounted() {
      $('#modal_mfa_save').on('hidden.bs.modal', () => {
        this.redirectUser();
      });
    },

    methods: {
      checkEnter(event) {
        if (event.key === 'Enter') {
          this.verifyCode();
        }
      },
      clearErrors: function () {
        this.has_error = false;
        this.message = '';
      },
      saveMFAInfo: function () {
        this.saving_mfa_info = true;
        this.saving_has_error = false;
        this.saving_message = '';

        axios
          .post('/save-mfa')
          .then((success) => {
            if (success.data.success) {
              this.redirectUser();
            } else {
              this.saving_message = success.data.message;
              this.saving_has_error = !success.data.success;
            }
            this.saving_mfa_info = false;
          })
          .catch((error) => {
            this.saving_has_error = true;
            this.saving_mfa_info = false;
            this.saving_message =
              'Error trying to save information. Please contact support.';
          });
      },
      verifyCode: function () {
        this.is_loading = true;
        this.has_error = false;
        this.message = '';

        axios
          .post('/verify-mfa', {
            user_id: this.user_id,
            code: this.code,
          })
          .then((success) => {
            if (success.data.success) {
              $('#modal_mfa_save').modal('show');
            } else {
              this.message = success.data.message;
              this.has_error = !success.data.success;
            }
            this.is_loading = false;
          })
          .catch((error) => {
            this.has_error = true;
            this.is_loading = false;
            this.message =
              'Error trying to send verification code. Please contact support.';
          });
      },
      resendCode: function () {
        this.resend_code_is_loading = true;
        axios
          .post('/api/v1/user/mfa/send', {
            user_id: this.user_id,
            mfa_type: this.mfa_type,
          })
          .then((success) => {
            this.resend_code_is_loading = false;
            this.message = success.data.message;
            this.has_error = !success.data.success;
          })
          .catch((error) => {
            this.has_error = true;
            this.resend_code_is_loading = false;
            this.message =
              'Error trying to send verification code. Please contact support.';
          })
          .finally(() => {
            // wait 3 seconds then hide response
            setTimeout(() => {
              this.message = '';
              this.has_error = false;
            }, 3000);
          });
      },
      redirectUser: function () {
        let redirect = this.redirect;
        if (redirect.includes('verify-account')) {
          redirect = '';
        }

        if (redirect.charAt(0) === '/') {
          redirect = redirect.substring(1);
        }

        // redirect user to area they were going
        window.location =
          location.protocol + '//' + location.hostname + '/' + redirect;
      },
    },
  };
</script>
